module.exports = __webpack_public_path__ + "img/shield-bios-banner-01.7a65a9db.jpg";